import { ISearch } from './ISearch.model';
import * as moment from 'moment';

export class Machine implements ISearch {
  public serialNumber: string;
  public productLine: string;
  public modelId: string;
  public modelName: string;
  public clientSerialNumber: string;
  public clientNumber: string;
  public year: number;
  search(query: string) {
    const queryToLower = query.toLowerCase();
    return this.serialNumber.toLowerCase().includes(queryToLower) || this.modelName.toLowerCase().includes(queryToLower);
  }
}

export class MachineInspection implements ISearch {
  public id: string;
  public name: string;
  public reportItemId: string;
  public customerName: string;
  public technicianName: string;
  public startDate: Date;
  public status: number;

  public search(query: string): boolean {
    const queryToLower = query.toLowerCase();

    let search =
      (this.name != null && this.name.toLowerCase().includes(queryToLower)) ||
      (this.technicianName != null && this.technicianName.toLowerCase().includes(queryToLower)) ||
      (this.startDate != null && moment(this.startDate).format('DD.MM.YYYY').includes(queryToLower)) ||
      (this.customerName != null && this.customerName.toLowerCase().includes(queryToLower));
    return search;
  }
}
